import { Button, MoveStepFunction, StepComponent, useTranslation } from '@helios/frontend-core';

import classNames from 'classnames';

interface StepperButtonsProps {
  previousStep: MoveStepFunction;
  nextStep: MoveStepFunction;
  onClose?: () => void;
  activeStepName: string;
  steps: StepComponent<any>[];
  parentTrackingId?: string;
}

export function StepperButtons({
  previousStep,
  nextStep,
  onClose,
  activeStepName,
  steps,
  parentTrackingId,
}: StepperButtonsProps) {
  const { t } = useTranslation();
  const currentIndex = steps.findIndex((s) => s.stepName === activeStepName);
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === steps.length - 1;

  const handleNext = () => {
    if (isLastStep) {
      onClose?.();
    } else {
      nextStep();
    }
  };

  const handlePrevious = () => {
    if (isFirstStep) return;
    previousStep();
  };

  return (
    <div className="pb-24">
      <div
        className={classNames('flex flex-col gap-12 w-full relative', {
          'mt-[-60px]': isFirstStep,
        })}
      >
        <div
          className={classNames('transition-transform duration-300 ease-in-out', {
            'translate-y-[60px]': isFirstStep,
            'translate-y-0': !isFirstStep,
          })}
        >
          <Button
            trackingId={`${parentTrackingId}-${activeStepName}-screen-${isLastStep ? 'finish' : 'continue'}-button`}
            onClick={handleNext}
            emphasis="primary"
            layout="fill"
          >
            {isLastStep ? t('common.letsGo') : t('common.continue')}
          </Button>
        </div>

        <div
          className={classNames('transition-all duration-300 ease-in-out overflow-hidden', {
            'opacity-0 transform translate-y-4 pointer-events-none': isFirstStep,
            'opacity-100 transform translate-y-0': !isFirstStep,
          })}
        >
          <Button
            trackingId={`${parentTrackingId}-${activeStepName}-screen-back-button`}
            onClick={handlePrevious}
            emphasis="secondary"
            layout="fill"
          >
            {t('common.back')}
          </Button>
        </div>
      </div>
    </div>
  );
}
